<template>
  <div class="user-details-sidebar">
    <div class="user-details-sidebar-item user-select-dropdown">
      <!-- TODO: v-model may not work here. If the v-model value is not contained in the dropdown items array, the dropdown displays "no data available" -->
      <v-autocomplete
        v-model="dropdownSelection"
        :items="userDropdownItems"
        :menu-props="{ contentClass: 'user-select-dropdown-menu' }"
        placeholder="Filter options"
        class="user-select-autocomplete"
        height="40px"
        attach="#userDetailsSidebarAttachTarget"
        solo
      >
        <template v-slot:append-outer>
          <div id="userDetailsSidebarAttachTarget"></div>
        </template>
      <!-- TODO: This should be enabled and reworked once we have actual data. We will need to query the API to get autocomplete results. -->
        <!-- <template v-slot:append-item> -->
          <!-- <div class="pagination-controls"> -->
            <!-- <button class="pagination-button" :disabled="userDrodownPageNum === 1" @click="loadPage('first')"><i class="fa fa-backward"></i></button> -->
            <!-- <button class="pagination-button" :disabled="userDrodownPageNum === 1" @click="loadPage('prev')"><i class="fa fa-caret-left"></i></button> -->
            <!-- <span class="pagination-text">Page {{userDrodownPageNum}} of 2</span> -->
            <!-- <button class="pagination-button" :disabled="userDrodownPageNum === 2" @click="loadPage('next')"><i class="fa fa-caret-right"></i></button> -->
            <!-- <button class="pagination-button" :disabled="userDrodownPageNum === 2" @click="loadPage('last')"><i class="fa fa-forward"></i></button> -->
          <!-- </div> -->
        <!-- </template> -->
      </v-autocomplete>
      <div class="user-icon-container"><v-icon class="user-icon">fa fa-user</v-icon></div>
      <div class="user-name">{{userData.name}}</div>
      <div class="user-email" :title="userData.email">{{userData.email}}</div>
    </div>
    <div class="user-details-sidebar-item user-profile">
      <span class="user-sidebar-header">Profile</span>
      <hr />
      <div class="user-sidebar-list-item"><v-icon class="user-sidebar-icon-mini">fa fa-user-circle</v-icon><span class="user-sidebar-list-item-text">{{userData.title}}</span></div>
      <div class="user-sidebar-list-item"><v-icon class="user-sidebar-icon-mini">far fa-id-card</v-icon><span class="user-sidebar-list-item-text">{{userData.department}}</span></div>
      <div class="user-sidebar-list-item"><v-icon class="user-sidebar-icon-mini">fa fa-map-marker-alt</v-icon><span class="user-sidebar-list-item-text">{{userData.location}}</span></div>
    </div>
    <div class="user-details-sidebar-item user-platforms">
      <span class="user-sidebar-header">Platforms</span>
      <hr />
      <div class="platform-license-grid">
        <div class="license-grid-icon"><i :class="getLicenseIconClass(userData.msTeamsLicense)"></i></div>
        <div class="license-grid-platform">MS Teams:</div>
        <div class="license-grid-status">{{userData.msTeamsLicense || 'Unknown'}}</div>
        <div class="license-grid-icon"><i :class="getLicenseIconClass(userData.webexLicense)"></i></div>
        <div class="license-grid-platform">Webex:</div>
        <div class="license-grid-status">{{userData.webexLicense || 'Unknown'}}</div>
        <div class="license-grid-icon"><i :class="getLicenseIconClass(userData.gmeetLicense)"></i></div>
        <div class="license-grid-platform">GMeet:</div>
        <div class="license-grid-status">{{userData.gmeetLicense || 'Unknown'}}</div>
        <div class="license-grid-icon"><i :class="getLicenseIconClass(userData.zoomLicense)"></i></div>
        <div class="license-grid-platform">Zoom:</div>
        <div class="license-grid-status">{{userData.zoomLicense || 'Unknown'}}</div>
      </div>
    </div>
  </div>
</template>

<script>
const DUMMY_USER_DATA_PAGE_1 = [
  'Andy Bernard',
  'Pam Beesly',
  'Nellie Bertram',
  'Kris Bryant',
  'Robert California',
  'Toby Flenderson',
  'Kelly Kapoor',
  'Jan Levinson',
  'Kevin Malone',
  'Jim Halpert'
];

// const DUMMY_USER_DATA_PAGE_2 = [
//   'Sleve McDichael',
//   'Onson Sweemey',
//   'Glenallen Mixon',
//   'Bobson Dugnutt',
//   'Willie Dustice',
//   'Mike Sernandez',
//   'Todd Bonzalez'
// ];

export default {
  name: 'user-details-sidebar',
  props: {
    userData: {
      type: Object,
      default: () => {}
    }
  },
  data: function() {
    return {
      // TODO: When we have real data we'll need to come up with a nice way to separate the v-model used for the dropdown from the data used elsewhere in the sidebar,
      //       so that clearing the dropdown value doesn't also clear all the info from the sidebar as a whole.
      selectedUser: 'Kris Bryant',
      dropdownSelection: 'Kris Bryant',
      userDropdownItems: [...DUMMY_USER_DATA_PAGE_1]
    }
  },
  methods: {
    getLicenseIconClass: function(licenseText) {
      if (!licenseText) {
        return {};
      }

      let cls = {
        'user-sidebar-icon-mini': true,
        'fas': true
      };
      if (licenseText.toLowerCase() === 'licensed') {
        cls['fa-check-circle'] = true;
      } else {
        cls['fa-times-circle'] = true;
      }
      return cls;
    }
  }
}
</script>

<style lang="scss" scoped>
  .user-details-sidebar {
    padding: 20px;
    .user-select-dropdown {
      margin: 20px auto;
      width: 198px;
      color: var(--text-color);

      .user-select-autocomplete {
        display: none !important; // todo remove when implemented
      }
      .user-icon-container {
        width: 100px;
        height: 100px;
        background-color: var(--background-color);
        border-radius: 50%;
        position: relative;
        margin: 0 auto;

        .user-icon {
          font-size: 61px;
          color: var(--neutral2-color); // was #6D787E; 4.63:1 on white
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .user-name {
        font-size: 24px;
        font-weight: 600;
        color: var(--text-color);
      }

      .user-email {
        margin-top: 13px;
        font-size: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        color: var(--text-color);
      }
    }

    .user-profile, .user-platforms {
      text-align: left;
      margin-bottom: 42px;

      hr {
        margin: 14px 0 20px;
        background-color: #BCBCBC;
        border: none;
        height: 1px;
      }

      .user-sidebar-header {
        font-size: 14px;
        font-weight: bold;
      }

      .user-sidebar-list-item {
        display: flex;
        margin-bottom: 10px;

        .user-sidebar-icon-mini {
          margin-right: 18px;
          flex: 1;
        }

        .user-sidebar-list-item-text {
          flex: 11;
        }
      }
    }

    .platform-license-grid {
      display: grid;
      grid-template-columns: 1fr 3fr 3fr;
      grid-row-gap: 10px;
    }


    .user-sidebar-icon-mini {
      font-size: 14px;
      color: #fff;
    }
  }
</style>

<style lang="scss">
#userDetails.v-application.user-details {
  .user-details-sidebar {
    display: flex;
    flex-direction: column;
    .user-select-dropdown {
      input {
        font-size: 14px;
      }

      .v-text-field .v-input__slot {
        border-radius: var(--border-radius);
        background-color: var(--filter-bg-color);
      }

      .v-text-field.v-select--is-menu-active .v-input__slot {
        background-color: #FFFFFF;
      }

      .v-input .v-input__append-inner {
        cursor: pointer;
      }

      .user-select-dropdown-menu {
        border-radius: var(--border-radius);

        // START Vuetify overrides
        // we need "!important" for some of these to override vuetify's styles that annoyingly use "!important" a lot
        .primary--text {
          color: #253035 !important;
          caret-color: #253035 !important;

          &::before {
            opacity: 0.06;
          }
        }

        .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
          color: #253035 !important;
        }
        // END Vuetify overrides

        .pagination-controls {
          text-align: center;

          .pagination-button {
            width: 25px;
            height: 25px;
            border: 1px solid #D5D5D5;
            border-radius: 3px;

            &:disabled i {
              color: #D5D5D5;
            }

            i {
              color: var(--filter-text-color);

              &.fa-backward, &.fa-forward {
                font-size: 9px;
                position: relative;
                bottom: 1px;
              }

              &.fa-caret-left, &.fa-caret-right {
                font-size: 12px;
                position: relative;
              }

              &.fa-caret-left {
                right: 1px;
              }

              &.fa-caret-right {
                left: 1px;
              }
            }
          }

          .pagination-text {
            font-size: 10px;
          }
        }
      }
    }
    @media (max-width: 991px) {
      flex-direction: row;
      justify-content: space-evenly;
      .user-details-sidebar-item {
        display: inline-block;
        margin: 0 10px;
      }
    }
    @media (max-width: 767px) {
      flex-direction: column;
      align-items: center;
      .user-name, .user-icon-container {
        display: none;
      }
    }
  }
}
</style>
